/*
 * Firebase web settings for the sign-up's OTP and leads, read from build
 * variables (CRA inlines REACT_APP_* at build time). The names are listed in
 * .env.example at the repo root; put the values in .env.local (git-ignored)
 * for local work, and in the hosting's build variables for a deploy.
 *
 * This module imports no Firebase SDK: the UI reads `isFirebaseConfigured`
 * from here, and the SDK is only loaded (lazily, see signupService.js) when a
 * code is actually sent. A build without the variables never loads it.
 *
 * The web config identifies the project; it is not a secret. Access is
 * enforced by firestore.rules and App Check, not by hiding these values.
 */
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const isFirebaseConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);
